"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALCULATOR = void 0;
exports.CALCULATOR = 'calculator';
//# sourceMappingURL=projectWhereItComesFrom.js.map